/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { GROUP_FRAGMENT } from '../fragments'

export const CREATE_GROUP = gql`
  mutation CreateGroup($name: String!) {
    createGroup(name: $name) {
      group {
        ...Group
      }
    }
  }
  ${GROUP_FRAGMENT}
`
